import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { ensurePulseProjectActive } from '../utils/pulseDeepLinkProject';
import { WORKSPACE_PULSE_PROJECT_ACCESS_TOAST } from '../utils/workspacePulseProjectAccess';
import { stashDeferredToast } from '../utils/deferredToast';

const PulseDeepLinkRedirect = ({ target }) => {
    const { projectId, taskId, irlId } = useParams();
    const dispatch = useDispatch();

    useEffect(() => {
        if (!projectId) {
            return undefined;
        }

        let cancelled = false;

        const resolveDestination = () => {
            switch (target) {
                case 'tasks':
                    return taskId ? `/tasks?taskId=${encodeURIComponent(taskId)}` : '/tasks';
                case 'irl':
                    return irlId ? `/irl?irlId=${encodeURIComponent(irlId)}` : '/irl';
                case 'dataroom':
                    return '/dataroom';
                case 'raid':
                    return '/raid';
                case 'raci':
                    return '/raci';
                case 'observations':
                    return '/observations';
                case 'action-log':
                    return '/action-log';
                default:
                    return '/overview';
            }
        };

        const activateProject = async () => {
            const ok = await ensurePulseProjectActive(dispatch, projectId);
            if (cancelled) {
                return;
            }
            if (!ok) {
                stashDeferredToast(WORKSPACE_PULSE_PROJECT_ACCESS_TOAST);
                window.location.replace('/project');
                return;
            }

            const destination = resolveDestination();
            // Hard navigation: React Router navigate() is deferred in background tabs (email links),
            // leaving "Opening project…" stuck until the tab regains focus.
            window.location.replace(destination);
        };

        void activateProject();

        return () => {
            cancelled = true;
        };
    }, [dispatch, projectId, target, taskId, irlId]);

    return (
        <div style={{ padding: 24, fontFamily: 'Inter, sans-serif', color: '#1b2149' }}>
            Opening project in Lens…
        </div>
    );
};

export default PulseDeepLinkRedirect;
